:host,
:host * {
	box-sizing: border-box;
}

.w2d-cookie-settings-link {
	@include type-link();
	color: inherit;
}
